export enum WaterfallTenderRateQuoteStatus {
  PENDING = 'PENDING',
  FAILED_TO_TENDER = 'FAILED_TO_TENDER',
  TENDERED = 'TENDERED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}
